/******************
 Modals
 ***************/

// open the BNPL Modal
document.querySelector('#cartAsideBnpl')?.addEventListener('click', function () {
    openModal(document.querySelector('.bnpl'));
})

// Checkout click
document.querySelector("#cartAsideCheckout")?.addEventListener("click", function () {
    var notice = document.querySelector('#shippingNotice');
    if (notice) { openModal(notice); } else { window.location.href = "/checkout"; }
});